'use es6';

import React from 'react';
import GoodDetailsContainer from './GoodDetailsContainer';

var GoodDetailsPreviewContainer = function GoodDetailsPreviewContainer(props) {
  return React.createElement(GoodDetailsContainer, Object.assign({}, props, {
    previewMode: true
  }));
};

export default GoodDetailsPreviewContainer;